import { type CourseState } from '@editor2/types/courseState';
import { applyPossiblyConflictingDiff } from '../conflictDetection/applyConflictingDiffAdapter';

export const applyPendingDiffHelper = (state: CourseState) => {
	const { nodes, commits, headCommit } = state.pendingDiff;

	// before diff apply
	state.diffNodes = nodes;
	state.commits = commits;
	state.isLoading = true;

	state = applyPossiblyConflictingDiff(state, nodes);

	// after diff apply
	state.diffNodes = state.conflicts.length ? nodes : [];
	state.commits = state.conflicts.length ? commits : [];
	state.isLoading = false;

	state.headCommit = headCommit;
	state.pendingDiff = null;

	return state;
};
